
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

Vue.use(VueRouter)
Vue.use(VueResource);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
 
import VueAnalytics from 'vue-analytics'




import App from './App.vue'
import LayoutTemplate from './components/Layout.vue'
import Song from './components/Song.vue'


const routes = [
    {
      path: '/',
      component: LayoutTemplate,
      children: [{
            path: ':slug',
            name: 'Song',
            component: Song
        }, { path: "*", component: Song },
        ],
    }
  ];



const router = new VueRouter({ 
	scrollBehavior: (to, from, savedPosition) => {
	    if (savedPosition) {
	      return savedPosition;
	    } else if (to.hash) {
	      return {
	        selector: to.hash
	      };
	    } else {
	      return { x: 0, y: 0 };
	    }
  },
    routes, 
    mode:'history' 
});

/*Vue.use(VueAnalytics, {
  id: 'UA-133162192-7',
  router
})*/


Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  //routes, not this
  render: h => h(App)
})
